<template>
  <div>
    <v-dialog v-model="getRlAddDialog.show" scrollable persistent max-width="90%">
        <v-card>
          <v-card-title>
            <span class="headline">Add Entries</span>
          </v-card-title>
          <v-card-text>
            <v-alert :value="getRlAddDialog.alert.show" dense outlined :type="getRlAddDialog.alert.type" :icon="getRlAddDialog.alert.icon">{{ getRlAddDialog.alert.message }}</v-alert>
            <v-progress-linear v-show="dialogLoading" height="3" indeterminate color="primary" /> 
            <v-form id="form" ref="addRlForm">           
            <v-data-table id="data-table" :server-items-length="getRlAddDialogList.length" :page="page" hide-default-footer height="50vh" :headers="rlEntriesHeaders" :items="getRlAddDialogList.slice((page - 1)* perPage, page* perPage)" disable-filtering fixed-header disable-sort class="elevation-1">
            <v-progress-linear height="3" indeterminate color="primary" />                    

              <template class="templateEntryType" id="templateEntryType" v-slot:item.entry_type_id="{ item }">
                <v-select class='entryType' id="entryType" v-model="item.entry_type_id" :items="getEntryTypeList" item-value="id" item-text="description" :rules="getRlDialogRules.required" dense disabled />
              </template>
              
              <template v-slot:item.trans_date="{ item }">
                <v-menu v-model="item.trans_date_picker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="item.trans_date" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense />
                  </template>
                  <v-date-picker v-model="item.trans_date" @input="item.trans_date_picker = false " />
                </v-menu>
              </template>

              <template v-slot:item.coll_dest_company="{ item }">
                <v-combobox name="coll_dest_company" v-model="item.coll_dest_company" :items="getCompanyListCalcItem(item)" @input="collDestCompanyChanged(item)" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>

              <template v-slot:item.coll_dest_country="{ item }">
                <v-select name="coll_dest_country" v-model="item.coll_dest_country" :items="getCompanyCountryCalcItem(item)" item-value="code" item-text="name" @input="collDestCountryChanged(item)" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax255]" clearable counter="255" maxlength="255" autocomplete="off" dense />
              </template>

              <template v-slot:item.coll_dest_city="{ item }">
                <v-combobox name="coll_dest_city"  v-model="item.coll_dest_city" :items="getCompanyCityCalcItem(item)" @input="collDestCityChanged(item)" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>

              <template v-slot:item.coll_dest_address="{ item }">
                <v-combobox name="coll_dest_address" v-model="item.coll_dest_address" :items="getCompanyAddressCalcItem(item)" @input="collDestAddressChanged(item)" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>

              <template v-slot:item.coll_dest_contact_name="{ item }">
                <v-combobox name="coll_dest_contact_name" v-model="item.coll_dest_contact_name" :items="getCompanyContactCalcItem(item)" @input="collDestContactNameChanged(item)" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>
              
              <template v-slot:item.coll_dest_contact_tel="{ item }">
                <v-text-field name="coll_dest_contact_tel" v-model="item.coll_dest_contact_tel" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>

              <template v-slot:item.coll_dest_contact_email="{ item }">
                <v-text-field name="coll_dest_contact_email" v-model="item.coll_dest_contact_email" :rules="[...getRlDialogRules.required, ...getRlDialogRules.email, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>

              <template v-slot:item.material_id="{ item }">
                <v-select v-model="item.material_id" :items="getMaterialList" item-value="id" item-text="description" :rules="getRlDialogRules.required" dense />
              </template>

              <template v-slot:item.grade_id="{ item }">
                <v-select v-model="item.grade_id" :items="getGradeMaterialList(item.material_id)" item-value="id" item-text="description" :rules="getRlDialogRules.required" no-data-text="Choose Material first" dense />
              </template>

              <template v-slot:item.spec="{ item }">
                <v-text-field name="spec" v-model="item.spec" :rules="getRlDialogRules.specification" type="text" autocomplete="off" dense />
              </template>

              <template v-slot:item.cont_perc="{ item }">
                <v-text-field name="cont_perc" v-model="item.cont_perc" suffix="%" @blur="contaminationPerc2Dec(item)" :rules="getRlDialogRules.percentage" type="number" autocomplete="off" dense />
              </template>

              <template v-slot:item.material_volume="{ item }">
                  <v-row justify="center" align="center" dense>
                    <v-col cols="7">
                      <v-text-field name="material_volume" v-model="item.material_volume" @blur="materialVolume2Dec(item)" :rules="[...getRlDialogRules.required, ...getRlDialogRules.money]" type="number" autocomplete="off" dense />
                    </v-col>
                    <v-col cols="5">
                      <v-select v-model="item.material_uom" :items="getUnitOfMeasureList" item-value="code" item-text="code" :rules="getRlDialogRules.required" dense />
                    </v-col>
                  </v-row>
              </template>

              <template v-slot:item.material_unit_price="{ item }">
                <v-row justify="center" align="center" dense>
                  <v-col cols="5">
                    <v-select v-model="item.material_unit_price_cc" :items="getCurrencyList" item-value="code" item-text="code" :rules="[...getRlDialogRules.required]" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field name="material_unit_price" v-model="item.material_unit_price" @blur="price2Dec(item, 'material_unit_price_cc', 'material_unit_price')" :rules="[...getRlDialogRules.required, ...getRlDialogRules.money]" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:item.incoterm_id="{ item }">
                <v-select v-model="item.incoterm_id" :items="getIncotermList" item-value="id" item-text="description" :rules="getRlDialogRules.required" dense />
              </template>
              
              <template v-slot:item.PRN_PERN_price="{ item }">
                  <v-row justify="center" align="center" dense>
                    <v-col cols="5">
                      <v-select v-model="item.PRN_PERN_price_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(item, 'PRN_PERN_price')" dense />
                    </v-col>
                    <v-col cols="7">
                      <v-text-field name="PRN_PERN_price" v-model="item.PRN_PERN_price" @blur="price2Dec(item, 'PRN_PERN_price_cc', 'PRN_PERN_price')" :rules="item.PRN_PERN_price_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" type="number" autocomplete="off" dense />
                    </v-col>
                  </v-row>
              </template>

              <template v-slot:item.dom_haul_cost="{ item }">
                <v-row justify="center" align="center" dense>
                  <v-col cols="5">
                    <v-select v-model="item.dom_haul_cost_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(item, 'dom_haul_cost')" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field name="dom_haul_cost" v-model="item.dom_haul_cost" @blur="price2Dec(item, 'dom_haul_cost_cc', 'dom_haul_cost')" :rules="item.dom_haul_cost_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:item.dom_haul_company="{ item }">
                <v-combobox name="dom_haul_company" v-model="item.dom_haul_company" :items="getHaulageCompanyCalcItem(item)" :rules="[...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>

              <template v-slot:item.dom_haul_booked="{ item }">
                <v-switch v-model="item.dom_haul_booked" dense />
              </template>

              <template v-slot:item.dom_haul_date="{ item }">
                <v-menu v-model="item.dom_haul_date_picker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field name="dom_haul_date" v-model="item.dom_haul_date" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense />
                  </template>
                  <v-date-picker v-model="item.dom_haul_date" @input="item.dom_haul_date_picker = false" />
                </v-menu>
              </template>

              <template v-slot:item.int_ship_cost="{ item }">
                <v-row justify="center" align="center" dense>
                  <v-col cols="5">
                    <v-select v-model="item.int_ship_cost_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(item, 'int_ship_cost')" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field name="int_ship_cost" v-model="item.int_ship_cost" @blur="price2Dec(item, 'int_ship_cost_cc', 'int_ship_cost')" :rules="item.int_ship_cost_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:item.int_ship_company="{ item }">
                <v-combobox v-model="item.int_ship_company" :items="getShippingCompanyCalcItem(item)" :rules="[...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>

              <template v-slot:item.int_ship_booked="{ item }">
                <v-switch v-model="item.int_ship_booked" dense />
              </template>

              <template v-slot:item.int_ship_date="{ item }">
                <v-menu v-model="item.int_ship_date_picker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field name="int_ship_date_picker" v-model="item.int_ship_date" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense />
                  </template>
                  <v-date-picker v-model="item.int_ship_date" @input="item.int_ship_date_picker = false" />
                </v-menu>
              </template>

              <template v-slot:item.insurance_cost="{ item }">
                <v-row justify="center" align="center" dense>
                  <v-col cols="5">
                    <v-select v-model="item.insurance_cost_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(item, 'insurance_cost')" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field name="insurance_cost" v-model="item.insurance_cost" @blur="price2Dec(item, 'insurance_cost_cc', 'insurance_cost')" :rules="item.insurance_cost_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:item.hs2="{ item }">
                <v-combobox v-model="item.hs2" :items="getHs2ListCalcItem(item)" :rules="[...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>

              <template v-slot:item.insp_company="{ item }">
                <v-combobox v-model="item.insp_company" :items="getInspectionCompanyCalcItem(item)" :rules="[...getRlDialogRules.stringMax50]" counter="50" maxlength="50" autocomplete="off" dense />
              </template>

              <template v-slot:item.insp_cost="{ item }">
                <v-row justify="center" align="center" dense>
                  <v-col cols="5">
                    <v-select v-model="item.insp_cost_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(item, 'insp_cost')" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field v-model="item.insp_cost" @blur="price2Dec(item, 'insp_cost_cc', 'insp_cost')" :rules="item.insp_cost_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:item.FX_rate="{ item }">
                <v-row justify="center" align="center" dense>
                  <v-col cols="5">
                    <v-select v-model="item.FX_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(item, 'FX_rate')" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field name="FX_rate" v-model="item.FX_rate" @blur="price2Dec(item, 'FX_cc', 'FX_rate')" :rules="item.FX_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:item.other_costs_desc="{ item }">
                <v-text-field v-model="item.other_costs_desc" :rules="[...getRlDialogRules.stringMax100]" counter="100" maxlength="100" autocomplete="off" dense />
              </template>

              <template v-slot:item.other_costs="{ item }">
                <v-row justify="center" align="center" dense>
                  <v-col cols="5">
                    <v-select v-model="item.other_costs_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(item, 'other_costs')" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field name="other_costs" v-model="item.other_costs" @blur="price2Dec(item, 'other_costs_cc', 'other_costs')" :rules="item.other_costs_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
              </template>

              <template v-slot:item.notes="{ item }">
                <v-text-field v-model="item.notes" :rules="[...getRlDialogRules.stringMax255]" counter="255" maxlength="255" autocomplete="off" dense />
              </template>

              <template v-slot:item.pictures="{ item }">
                <v-badge :content="item.images.savedImages.length" :value="item.images.savedImages.length" color="green" left overlap>
                  <v-icon @click.prevent="openRlImagesAddDialog(item)">insert_photo</v-icon>
                </v-badge>
              </template>

              <template v-slot:item.actions="{ item }">                
                <v-icon @click.prevent="deleteEntry(item)">delete</v-icon>               
              </template>    
              <template v-slot:item.view="{ item }">
                <v-icon @click.prevent="openRlEntryAddDialogView2(item)">keyboard_capslock</v-icon>		
              </template>
              <template >                        
              </template>       
            </v-data-table>      
            <v-layout row justify-center>             
              <v-row justify="start" align="center" align-content="center" dense>                          
                  <v-btn color="primary" @click.native="savePurchases()" id="addPurchase" class="ma-2">Add Purchase</v-btn> 
                  <v-btn color="primary" @click.native="saveSales()" id="addSales" class="ma-2">Add Sales</v-btn> 
                  <template><read-excel @changeIsLoading="changeIsLoading" @validateForm="validateForm" /></template>         
               <v-spacer />
                <v-col cols="3" class="text-right">
                    <v-pagination light v-model="page" :length="Math.ceil(getRlAddDialogList.length/perPage)"></v-pagination>
                </v-col>
              </v-row>                   
            </v-layout>      
          </v-form> 
          </v-card-text>
          <v-card-actions>
            <v-spacer />            
            <v-btn color="primary darken-1" text @click.prevent="closeDialog()" :disabled="dialogLoading">Close</v-btn>
            <v-btn color="primary" @click.prevent="saveDialog()" :disabled="dialogLoading">Save</v-btn>
          </v-card-actions>
        </v-card>  
          <v-overlay :value="dialogLoading">
           <v-progress-circular indeterminate  color="amber" size="64"></v-progress-circular>
          </v-overlay>   
      </v-dialog>       
      <rl-image-add-dialog />    
  </div>
</template>
<script>

import ReadExcel from "../ReadExcel.vue"
import axios from 'axios'
import RlImageAddDialog from '../recyclingLedgerEntryImage/AddDialog.vue'
import AddDialogSlimView from './AddDialogSlimView'
import { editDialogValidation } from '../../mixins/editDialogValidation.js'
import { mapActions } from 'vuex'

export default {
	components: { 
    RlImageAddDialog: RlImageAddDialog,
    AddDialogSlimView: AddDialogSlimView, 
    ReadExcel: ReadExcel,   
  }, 
  mixins: [editDialogValidation],
	data() {
		return {        
      isShowAddDialogSlimView: false,     
      pagination: {},  
      perPage: 10,
      page: 1,     
      rlEntriesHeaders: [
        {text: 'View', value: 'view', sortable: false, width: 50},
				{text: 'Entry Type*', value: 'entry_type_id', width: 150},
        {text: 'Transaction Date*', value: 'trans_date', width: 150},
        {text: 'Collection/Destination Company Name*', value: 'coll_dest_company', width: 200},
				{text: 'Collection/Destination Country*', value: 'coll_dest_country', width: 200},
				{text: 'Collection/Destination City*', value: 'coll_dest_city', width: 200},
				{text: 'Collection/Destination Address*', value: 'coll_dest_address', width: 200},
				{text: 'Collection/Destination Contact Name*', value: 'coll_dest_contact_name', width: 200},
				{text: 'Collection/Destination Contact Tel*', value: 'coll_dest_contact_tel', width: 200},
				{text: 'Collection/Destination Contact Email*', value: 'coll_dest_contact_email', width: 200},
        {text: 'Material*', value: 'material_id', width: 200},
				{text: 'Grade*', value: 'grade_id', width: 200},
        {text: 'Specification*', value: 'spec', width: 150},
        {text: 'Contamination Percentage', value: 'cont_perc', width: 100},
				{text: 'Material Volume*', value: 'material_volume', width: 240},
				{text: 'Material Unit Price*', value: 'material_unit_price', width: 240},
        {text: 'Incoterm*', value: 'incoterm_id', width: 250},
				{text: 'PRN/PERN Price', value: 'PRN_PERN_price', width: 240},
        {text: 'Domestic Haulage Cost', value: 'dom_haul_cost', width: 240},
        {text: 'Domestic Haulage Company', value: 'dom_haul_company', width: 200},
				{text: 'Domestic Haulage Booked', value: 'dom_haul_booked', width: 200},
        {text: 'Domestic Haulage Collection Date', value: 'dom_haul_date', width: 200},
        {text: 'International Shipping Cost', value: 'int_ship_cost', width: 240},
				{text: 'International Shipping Company', value: 'int_ship_company', width: 200},
				{text: 'International Shipping Booked', value: 'int_ship_booked', width: 200},
				{text: 'International Shipping Collection Date', value: 'int_ship_date', width: 200},
				{text: 'Insurance Cost', value: 'insurance_cost', width: 240},
				{text: 'HS2', value: 'hs2', width: 200},
        {text: 'Inspection Company', value: 'insp_company', width: 200},
        {text: 'Inspection Cost', value: 'insp_cost', width: 240},
				{text: 'FX Rate', value: 'FX_rate', width: 240},
        {text: 'Other Costs Description', value: 'other_costs_desc', width: 200},
				{text: 'Other Costs', value: 'other_costs', width: 240},
        {text: 'Notes', value: 'notes', sortable: false, width: 300},
        {text: 'Pictures', value: 'pictures', sortable: false, width: 150},
        {text: 'Actions', value: 'actions', sortable: false, width: 150}
      ],      
      defaultEntries: {
        entry_type_id: 1,
        trans_date: new Date().toISOString().substr(0, 10),
        trans_date_picker: false,
        coll_dest_company: null,
        coll_dest_country: null,
        coll_dest_city: null,
        coll_dest_address: null,
        coll_dest_contact_name: null,
        coll_dest_contact_tel: null,
        coll_dest_contact_email: null,
        material_id: null,
        grade_id: null,
        spec: null,
        cont_perc: null,
        material_volume: null,
        material_uom: null,
        material_unit_price_cc: null,
        material_unit_price: null,
        PRN_PERN_price_cc: null,
        PRN_PERN_price: null,
        dom_haul_cost_cc: null,
        dom_haul_cost: null,
        dom_haul_booked: 0,
        dom_haul_date_picker: false,
        int_ship_cost_cc: null,
        int_ship_cost: null,
        int_ship_booked: 0,
        int_ship_date_picker: false,
        insurance_cost_cc: null,
        insurance_cost: null,
        insp_cost_cc: null,
        insp_cost: null,
        FX_cc: null,
        FX_rate: null,
        other_costs_cc: null,
        other_costs: null,
        images: { shownImages: [], savedImages: [] }
      },    
      dialogLoading: false,
		}
  }, 
  mounted() {
    this.setCompanyList()
    this.setHs2List()
		this.setDomesticCompanyList()
		this.setShippingCompanyList()
    this.setInspectionCompanyList()       
  },
  watch: {
    getRlAddDialogList: {
      handler() {
        this.$refs.addRlForm.validate()
			}
    },
		excelData: {
			handler() {		
				this.handleAddExcelData()
			}
		},	
	},
	methods: {  
    savePurchases() {
      this.defaultEntries.entry_type_id = 1
      this.setRlAddDialogList(this.defaultEntries)
    },
    saveSales(){
      this.defaultEntries.entry_type_id = 2
      this.setRlAddDialogList(this.defaultEntries)
    },
    ...mapActions([      
      'setRlAddDialogList'
		]),
    changeIsLoading(isLoading){    
      this.dialogLoading = isLoading;    
    },
    validateForm(){
      this.$refs.addRlForm.validate() 
    },
   	openRlEntryAddDialogView2(item) {
			this.setRlEntryAddDialogView2({show: true, item: item})
    },  
    closeDialog() {
      this.setRlAddDialog({show: false, alert: {show: false, type: null, icon: null, message: null}})
    },
    getIndexsRlAddDialogListImages(){
      let indexWithImages = [];
      let indexWithoutImages = [];
      this.getRlAddDialogList.forEach( (entry, index) => {
        (entry.images.savedImages.length) ? indexWithImages.push(index) : indexWithoutImages.push(index);
      })
      return {"indexWithImages": indexWithImages,"indexWithoutImages": indexWithoutImages }
    },
    async saveDialog() {
      if (this.$refs.addRlForm.validate() && this.getRlAddDialogList.length > 0) {
        try {          
          let response2;
          let response3;
          let entriesWithoutImages = []; 
          this.dialogLoading = true
          var formData = new FormData()

          const indexImages = this.getIndexsRlAddDialogListImages();         

          indexImages.indexWithoutImages.forEach( i => {
            entriesWithoutImages.push(this.getRlAddDialogList[i])
          })

          if(entriesWithoutImages.length){           
            let dataJson = JSON.stringify(entriesWithoutImages)
            response3 = await axios.post('api/v1/recyclingLedgerEntries', dataJson)

            if(!response3.status === 200){
              this.setRlAddDialog({show: true, alert: {show: true, type: "error", icon: "error", message: response3.data.message}})            
            }          
          }        
          if(indexImages.indexWithImages.length){           
            for(let i=0; i<indexImages.indexWithImages.length; i++){             
              
              const index = indexImages.indexWithImages[i]           
             
              let x = Object.assign({} ,this.getRlAddDialogList[index])
              x.images = []              
              formData.append('data', JSON.stringify(x))

              if (this.getRlAddDialogList[index].images.savedImages.length) {
                for (let image of this.getRlAddDialogList[index].images.savedImages) {
                  formData.append('images[]', image, image.name)
                }
              }          
              
              response2 = await axios.post('api/v1/recyclingLedgerEntries', formData)

              formData.delete('data')
              formData.delete('images[]')
              if(!response2.status === 200){
                this.setRlAddDialog({show: true, alert: {show: true, type: "error", icon: "error", message: response2.data.message}})
                break;
              }            
            }   
          }              
          if (this.checkStatusRes(response2, response3, indexImages.indexWithImages, indexImages.indexWithoutImages)){           
            this.dialogLoading = false            
            this.setRlAddDialog({show: false, alert: {show: false, type: null, icon: null, message: null}})
            this.setRlEntryList()
            this.clearRlAddDialogList()
          }
        }catch (error) {
          this.dialogLoading = false
          this.setRlAddDialog({show: true, alert: {show: true, type: "error", icon: "error", message: error.response.data.message}})
        }
      }
    },
    checkStatusRes(res2, res3, indexWith, indexWithout){
      let a = false
      if(indexWithout.length){
        a = false;
        if(res3.status){
          if( res3.status === 200){
            a = true;
          }
        }
      }
      if(indexWith.length){
        a = false;
        if(res2.status){
          if(res2.status === 200){
            a=true;
          }
        }
      }
      return a;
    },	
    deleteEntry(item) {
      this.deleteRlAddDialogList(item)
    },
    openRlImagesAddDialog(item) {
      this.setRlImageAddDialog({ show: true, item: item })
    },  
  }
}
</script>

<style scoped>  
  tr{
    height: 71.2px
  }
	input[type="file"] {
		display: none;		
	}	 
  li.VuePagination__pagination-item:not(.VuePagination__pagination-item-prev-page):not(.VuePagination__pagination-item-prev-chunk):not(.VuePagination__pagination-item-next-page):not(.VuePagination__pagination-item-next-chunk) {
    display: none;
  }
</style>


